import Api from "../api/api";

export default {
  state: {
    domain: "",
    downLink: {},
  },
  actions: {
    getStatus({ commit }, payload) {
      return Api.status(payload).then((res) => {
        const { domainRoute, resources } = res.value.info;
        const [firstLink] = domainRoute;
        commit("setDomain", firstLink.domainName);
        commit("setDownLinks", resources);
      });
    },
  },
  mutations: {
    setDomain(state, value) {
      state.domain = value;
    },
    setDownLinks(state, resources) {
      const results = resources.reduce((prev, curr) => {
        return { ...prev, [curr.resourceType]: curr };
      }, {});
      state.downLink = results;
    },
  },
};
